import { TestimonialCard } from "@/design-system/Molecules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import type { Testimonial } from "@/rtkQuery/features/models/testimonial.model";

type ImageSliderProps = {
  testimonials?: Testimonial[];
  pageName?: string;
};

const ImageSlider = ({ testimonials = [], pageName }: ImageSliderProps) => {
  return (
    <Swiper
      modules={[Navigation]}
      slidesPerView={1}
      spaceBetween={20}
      navigation={{
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }}
      className="mySwiper testimonial"
    >
      {testimonials
        .filter((t) => t.FirstName?.trim())
        .map((t, idx) => (
          <SwiperSlide key={idx}>
            <TestimonialCard
              message={t.Message}
              firstName={t.FirstName}
              pageName={pageName}
            />
          </SwiperSlide>
        ))}

      <div className="swiper-controls hidden lg:flex py-4 relative mt-10 gap-4">
        <div
          className="swiper-button-prev w-[80px] h-[60px] bg-[url('/images/icon-testimonial-prev.svg')] bg-center bg-no-repeat bg-contain hover:rounded-md hover:shadow-[0_0_0_4px_#d6d9e1] transition-all duration-300 cursor-pointer"
          role="button"
          tabIndex={0}
        />
        <div
          className="swiper-button-next w-[80px] h-[60px] bg-[url('/images/icon-testimonial-next.svg')] bg-center bg-no-repeat bg-contain hover:rounded-md hover:shadow-[0_0_0_4px_#d6d9e1] transition-all duration-300 cursor-pointer"
          role="button"
          tabIndex={0}
        />
      </div>
    </Swiper>
  );
};

export default ImageSlider;
